import { NodeIndexOutlined } from "@ant-design/icons";

import { ButtonDelete } from "../../../../ButtonDelete";
import { handleExtensionIntentNode } from "../../../../utils/removeDataNode";
import { useFlowNodes } from "../../../../../context";

import "./ExtensionHeader.scss";

const ExtensionHeader = ({ id }) => {
  const { t, setEdges, setNodes, updateIntent, updateVariables } =
    useFlowNodes();

  return (
    <div className="extensions-header">
      <div className="extensions-icon">
        <NodeIndexOutlined />
      </div>
      <div className="extensions-title-wrapper">
        <span className="extensions-title">
          {t("common:intents.flow_chat.extensions.title")}
        </span>
      </div>
      <ButtonDelete
        setNodes={setNodes}
        setEdges={setEdges}
        nodeId={id}
        handleDelete={() => {
          handleExtensionIntentNode(updateIntent);
          updateVariables([]);
        }}
      />
    </div>
  );
};

export default ExtensionHeader;
